export enum PaymentType {
  CARD = 1,
  CASH = 2,
}
